import React from "react";
import { Helmet } from "react-helmet";
import { ItemGridDragDropTitleStyle } from "../../components/grid-drag-drop/ItemGridDragDropTitleStyle";
import { Grid, IconButton } from "@material-ui/core";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import { LightTooltip, Margin } from "../../styles/GlobalStyle";
import CachedOutlinedIcon from "@material-ui/icons/CachedOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { DividerStyled } from "../../components/chat/styles/GeneralStyle";
import useDashboardViewController from "../../pages/dashboard/controllers/DashboardViewController";

export const WidgetVersion49 = () => {
  const { handleDeleteWidgets } = useDashboardViewController();

  const item = {
    i: "49",
    importScripts: ["https://cdn.jsdelivr.net/npm/chart.js"],
    stringScripts: [""],
    onRefresh: `
    try {
        const GECP_ENVIRONMENT = localStorage.getItem("environment") ?? "test";
        const GECP_ERP_API_URL = GECP_ENVIRONMENT === "prod" ? "https://qerpapi.qyon.com" :
            GECP_ENVIRONMENT === "beta" ? "https://beta-qerpapi.qyon.com" :
            GECP_ENVIRONMENT === "dev" ? "http://localhost:85" :
            "https://test-qerpapi.qyon.com";
    
        const GECP_ERP_API_TOKEN = GECP_ENVIRONMENT === "prod" ? "eVmDI3J6dCqvxDUyZv16Sr1KBDW0TTNKvZA4LCkY" : "eyJ0ZXN0ZSI6InJhZmFvbGluZG9zejEyMyJ9";
        const documentPanel = localStorage.getItem("documentPanel");
    
        const GECP_getCPStatus = async () => {
            const GECP_CPStatusData = await fetch(
                \`\${GECP_ERP_API_URL}/api/erp/financeiro/contaspagar/v1/status?\${new URLSearchParams({empresa_cnpj: documentPanel})}\`,
                {
                    method: "GET",
                    headers: new Headers({ Authorization: GECP_ERP_API_TOKEN })
                }
            )
            .then((res) => {
                if (res.ok) {
                    return res.json();
                }
                throw res.statusText;
            })
            .catch((error) => {
                console.error("Widget GE - Contas Pagar, fetch error:", error);
                if (document.getElementById("GECP_fetchError")) {
                    document.getElementById("GECP_fetchError").style.display = "flex";
                    document.getElementById("GECP_loaderAnimation").style.display = "none";
                }
            });
            return GECP_CPStatusData?.success ? GECP_CPStatusData.data : false;
        };
    
        const GECP_populateCP = async () => {
            try {
                let GECP_CPStatusReturn = await GECP_getCPStatus();
                if (GECP_CPStatusReturn && document.getElementById("GECP_content")) {
                    document.getElementById("GECP_totalPayLate").innerHTML = GECP_numberUStoBR(GECP_CPStatusReturn.totalPayLate);
                    document.getElementById("GECP_totalPayLastMonth").innerHTML = GECP_numberUStoBR(GECP_CPStatusReturn.totalPayPreviousMonth);
                    document.getElementById("GECP_totalPayNextMonth").innerHTML = GECP_numberUStoBR(GECP_CPStatusReturn.totalPayNextMonth);
                    document.getElementById("GECP_totalPayFutures").innerHTML = GECP_numberUStoBR(GECP_CPStatusReturn.totalPayFutures);
                    if (GECP_CPStatusReturn.inMonth) {
                        document.getElementById("GECP_content").style.display = "flex";
                        GECP_renderChartJs(GECP_CPStatusReturn.inMonth);
                    }
                }
            } catch (error) {
                console.error("Widget GE - Contas Pagar, populate error:", error);
                document.getElementById("GECP_fetchError").style.display = "flex";
                document.getElementById("GECP_content").style.display = "none";
            } finally {
                if (document.getElementById("GECP_loaderAnimation")) {
                    document.getElementById("GECP_loaderAnimation").style.display = "none";
                }
            }
        };
    
        function GECP_renderChartJs(inMonth) {
            document.getElementById("GECP_chartContainer").innerHTML = "";
            document.getElementById("GECP_chartContainer").innerHTML = '<canvas id="GECP_ChartCanvas" style="max-height: 100%"></canvas>';
            const GECP_data = {
                labels: ["Em aberto", "Pago", "Em atraso"],
                datasets: [{
                    label: "My First Dataset",
                    data: [inMonth.open, inMonth.paid, inMonth.late],
                    backgroundColor: [
                        "rgb(255, 205, 86)",
                        "rgb(54, 162, 235)",
                        "rgb(255, 99, 132)"
                    ],
                    hoverOffset: 4
                }]
            };
            const GECP_config = {
                type: "doughnut",
                data: GECP_data,
                options: {
                    plugins: {
                        subtitle: {
                            display: true,
                            text: "No mês"
                        },
                        legend: {
                            position: "bottom",
                            labels: {
                                boxWidth: 8,
                                boxHeight: 8,
                                usePointStyle: true,
                                font: { size: 10 }
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: function (context) {
                                    return \`R$ \${GECP_numberUStoBR(context.parsed)}\`;
                                }
                            }
                        }
                    }
                }
            };
            const GECP_myChart = new Chart(
                document.getElementById("GECP_ChartCanvas"),
                GECP_config
            );
        }
    
        function GECP_numberUStoBR(number) {
            return number.toLocaleString("pt-br", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    
        document.getElementById("GECP_loaderAnimation").style.display = "block";
        document.getElementById("GECP_fetchError").style.display = "none";
        document.getElementById("GECP_content").style.display = "none";
    
        try {
            GECP_populateCP();
        } catch (error) {
            console.error("Widget GE - Contas Pagar, error:", error);
            document.getElementById("GECP_fetchError").style.display = "flex";
            document.getElementById("GECP_loaderAnimation").style.display = "none";
        }
    } catch (err) {}
    `,
    refreshOnLoad: true,
  };

  return (
    <>
      {item.importScripts.map((script, index) => {
        return (
          <div key={`import_${index}`}>
            <Helmet>
              <script async src={script}></script>
            </Helmet>
          </div>
        );
      })}

      <ItemGridDragDropTitleStyle customStyle={item.headerStyle ?? {}}>
        <Grid item container justifyContent="space-between" alignItems="center">
          <Grid item flex={1}>
            <IconButton size="small">
              <DragIndicatorIcon style={{ fontSize: 18, marginRight: 5 }} />
            </IconButton>
            Contas a Pagar
          </Grid>
          <Grid item flex={1}>
            <Grid item container alignItems="center">
              <Margin top="7" />
              {item.onRefresh &&
                (() => {
                  if (item?.refreshOnLoad) {
                    setTimeout(() => {
                      try {
                        // eslint-disable-next-line no-eval
                        eval("try{" + item.onRefresh + "}catch(err){}");
                      } catch (error) {
                        console.error(error);
                      }
                    }, 1500);
                  }

                  return (
                    <Grid item flex={1}>
                      <LightTooltip title="Atualizar">
                        <CachedOutlinedIcon
                          style={{
                            fontSize: 18,
                            marginRight: 10,
                            cursor: "pointer",
                            color: "#636363",
                          }}
                          onClick={() => {
                            // Muito cuidado, o eval é perigoso - https://developer.mozilla.org/pt-BR/docs/Web/JavaScript/Reference/Global_Objects/eval
                            try {
                              // eslint-disable-next-line no-eval
                              eval("try{" + item.onRefresh + "}catch(err){}");
                            } catch (error) {
                              console.error(error);
                            }
                          }}
                        />
                      </LightTooltip>
                    </Grid>
                  );
                })()}
              <Grid item flex={1}>
                <LightTooltip title="Remover">
                  <CloseIcon
                    style={{
                      fontSize: 18,
                      cursor: "pointer",
                      color: "#636363",
                      marginRight: 10,
                    }}
                    onClick={() => handleDeleteWidgets(item)}
                  />
                </LightTooltip>
              </Grid>
            </Grid>
          </Grid>
          <DividerStyled style={{ width: "100%" }} />
        </Grid>
      </ItemGridDragDropTitleStyle>

      <div
        style={{
          height: `${"calc(100% - 65px)"}`,
          width: "100%",
        }}
      >
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;400&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/icon?family=Material+Icons+Round"
          rel="stylesheet"
        />
        <style>
          {`@keyframes GECP_spinner-grow {
          0% {transform: scale(0);}
          50% {opacity: 1;transform: none;}
        }`}
        </style>
        <div
          id="GECP_widget"
          style={{
            height: "100%",
            fontFamily: "Roboto, sans-serif",
            position: "relative",
          }}
        >
          <div
            id="GECP_loaderAnimation"
            style={{
              color: "#006fde",
              display: "none",
              width: "5rem",
              height: "5rem",
              verticalAlign: "-0.125em",
              backgroundColor: "currentColor",
              borderRadius: "50%",
              opacity: 0,
              animation: "GECP_spinner-grow 0.75s linear infinite",
              position: "absolute",
              top: "calc(50% - 2.5rem)",
              left: "calc(50% - 2.5rem)",
            }}
          ></div>
          <div
            id="GECP_fetchError"
            style={{
              position: "absolute",
              width: "calc(100% - 20px)",
              height: "100%",
              display: "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span
              className="material-icons-round"
              style={{ fontSize: "3em", margin: "8px" }}
            >
              error_outline
            </span>
            <p>
              Não foi possível carregar os dados
              <br />
              Tente novamente
            </p>
          </div>
          <div
            id="GECP_content"
            style={{ width: "100%", height: "100%", display: "flex" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                height: "100%",
                width: "45%",
                borderLeft: "4px solid #FA3A3A",
                paddingLeft: "12px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                  R$ <span id="GECP_totalPayLate">-</span>
                </div>
                <hr
                  style={{
                    width: "40%",
                    border: "none",
                    height: "1px",
                    color: "#ddd",
                    backgroundColor: "#ddd",
                    margin: "4px auto 4px 0",
                  }}
                />
                <span style={{ fontSize: "0.8em", color: "#777777" }}>
                  Total Atrasado
                </span>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                  R$ <span id="GECP_totalPayLastMonth">-</span>
                </div>
                <hr
                  style={{
                    width: "40%",
                    border: "none",
                    height: "1px",
                    color: "#ddd",
                    backgroundColor: "#ddd",
                    margin: "4px auto 4px 0",
                  }}
                />
                <span style={{ fontSize: "0.8em", color: "#777777" }}>
                  Atrasados Último Mês
                </span>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                  R$ <span id="GECP_totalPayNextMonth">-</span>
                </div>
                <hr
                  style={{
                    width: "40%",
                    border: "none",
                    height: "1px",
                    color: "#ddd",
                    backgroundColor: "#ddd",
                    margin: "4px auto 4px 0",
                  }}
                />
                <span style={{ fontSize: "0.8em", color: "#777777" }}>
                  Pagamentos Próximo Mês
                </span>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <div style={{ fontSize: "1.2em", fontWeight: "bold" }}>
                  R$ <span id="GECP_totalPayFutures">-</span>
                </div>
                <hr
                  style={{
                    width: "40%",
                    border: "none",
                    height: "1px",
                    color: "#ddd",
                    backgroundColor: "#ddd",
                    margin: "4px auto 4px 0",
                  }}
                />
                <span style={{ fontSize: "0.8em", color: "#777777" }}>
                  Total de Pagamentos Futuros
                </span>
              </div>
            </div>
            <div
              id="GECP_chartContainer"
              style={{ display: "flex", width: "55%", height: "100%" }}
            >
              <canvas
                id="GECP_ChartCanvas"
                style={{ maxHeight: "100%" }}
              ></canvas>
            </div>
          </div>
        </div>
      </div>

      {item.stringScripts &&
        item.stringScripts.map((script, index) => {
          return (
            <div key={`script_${index}`}>
              <Helmet>
                <script async>{script}</script>
              </Helmet>
            </div>
          );
        })}
    </>
  );
};
